/* DBR Price Filter v5 */
(function () {
  var CHECK = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-checkmark"><path d="M4.75439 10.7485L7.68601 14.5888C7.79288 14.7288 7.84632 14.7988 7.91174 14.8242C7.96907 14.8466 8.03262 14.8469 8.09022 14.8253C8.15596 14.8007 8.21026 14.7314 8.31886 14.5927L15.2475 5.74658" stroke="currentColor" stroke-width="var(--icon-stroke-width, 1.5)" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var THUMB_COLOR = '#592658';
  var THUMB_SIZE = 16;
  var storedRangeMax = 0;

  function getSort() {
    return new URLSearchParams(window.location.search).get('sort_by') || '';
  }

  function applySort(sortVal, checkbox) {
    document.querySelectorAll('.dbr-sort-cb').forEach(function (cb) { cb.checked = false; });
    var isActive = getSort() === sortVal;
    if (!isActive) checkbox.checked = true;

    var url = new URL(window.location.href);
    if (isActive) { url.searchParams.delete('sort_by'); }
    else { url.searchParams.set('sort_by', sortVal); }

    var ff = document.querySelector('facets-form-component');
    if (ff && typeof ff.updateFiltersByURL === 'function') {
      ff.updateFiltersByURL(url.toString());
    } else {
      window.location.href = url.toString();
    }
  }

  function applyMaxPrice(val, rangeMax) {
    var ff = document.querySelector('facets-form-component');
    if (!ff) return;
    var url = new URL(window.location.href);
    if (val < rangeMax) { url.searchParams.set('filter.v.price.lte', String(val)); }
    else { url.searchParams.delete('filter.v.price.lte'); }
    url.searchParams.delete('filter.v.price.gte');

    if (typeof ff.updateFiltersByURL === 'function') {
      ff.updateFiltersByURL(url.toString());
    } else {
      window.location.href = url.toString();
    }
  }

  function initSlider(facet) {
    if (facet.querySelector('.dbr-ps')) return;

    /* ---- Range max ---- */
    var rangeMax = storedRangeMax;
    if (!rangeMax) {
      var det = facet.closest('details');
      if (det) {
        var s = det.querySelector('[data-range-max]');
        if (s) rangeMax = parseFloat(s.getAttribute('data-range-max')) / 100 || 0;
      }
    }
    if (!rangeMax) {
      var mi = facet.querySelector('[ref="maxInput"]');
      if (mi && mi.getAttribute('data-max')) rangeMax = parseFloat(mi.getAttribute('data-max')) || 0;
    }
    if (!rangeMax) rangeMax = 3000;
    storedRangeMax = rangeMax;

    var step = 50;
    if (rangeMax > 5000) step = 250;
    else if (rangeMax > 2000) step = 100;
    var sliderMax = Math.ceil(rangeMax / step) * step;

    var urlMax = new URLSearchParams(window.location.search).get('filter.v.price.lte');
    var maxVal = urlMax ? snap(parseFloat(urlMax)) : sliderMax;

    function snap(v) { return Math.round(v / step) * step; }
    /* Map value to percentage within the padded track area */
    function pct(v) { return (v / sliderMax) * 100; }

    /* ---- Hide existing content ---- */
    var ch = facet.firstChild;
    while (ch) {
      if (ch.nodeType === 1 && !ch.classList.contains('dbr-ps')) {
        ch.style.cssText = 'position:absolute!important;width:0!important;height:0!important;overflow:hidden!important;opacity:0!important;pointer-events:none!important;';
      } else if (ch.nodeType === 3) { ch.textContent = ''; }
      ch = ch.nextSibling;
    }

    /* ==== Container ==== */
    var wrap = document.createElement('div');
    wrap.className = 'dbr-ps';
    var isHoriz = facet.closest('.facets--horizontal');
    wrap.style.cssText = 'display:flex;flex-direction:column;' + (isHoriz ? 'padding:var(--padding-md, 12px);' : '');

    /* ==== Sort checkboxes ==== */
    var curSort = getSort();

    function mkCb(label, sortVal) {
      var div = document.createElement('div');
      div.className = 'checkbox';

      var inp = document.createElement('input');
      inp.type = 'checkbox';
      inp.className = 'checkbox__input dbr-sort-cb';
      inp.id = 'dbr-s-' + sortVal + '-' + Math.random().toString(36).slice(2, 6);
      if (curSort === sortVal) inp.checked = true;

      var lbl = document.createElement('label');
      lbl.className = 'checkbox__label';
      lbl.setAttribute('for', inp.id);
      lbl.setAttribute('role', 'checkbox');
      lbl.innerHTML = CHECK + '<span class="checkbox__label-text">' + label + '</span>';

      div.appendChild(inp);
      div.appendChild(lbl);

      div.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        applySort(sortVal, inp);
      });

      return div;
    }

    var sortList = document.createElement('ul');
    sortList.className = 'facets__inputs-list list-unstyled';
    sortList.style.cssText = 'display:flex;flex-direction:column;margin:0;padding:0;';

    var li1 = document.createElement('li');
    li1.className = 'facets__inputs-list-item';
    li1.appendChild(mkCb('Lowest to highest', 'price-ascending'));
    var li2 = document.createElement('li');
    li2.className = 'facets__inputs-list-item';
    li2.appendChild(mkCb('Highest to lowest', 'price-descending'));
    sortList.appendChild(li1);
    sortList.appendChild(li2);

    /* ==== Slider section ==== */
    var sliderWrap = document.createElement('div');
    sliderWrap.style.cssText = 'padding-top:14px;margin-top:14px;border-top:1px solid rgba(0,0,0,0.08);';

    var labelRow = document.createElement('div');
    labelRow.style.cssText = 'display:flex;justify-content:space-between;align-items:center;margin-bottom:6px;';
    var titleSpan = document.createElement('span');
    titleSpan.textContent = 'Max price';
    titleSpan.style.cssText = 'font-size:0.85em;opacity:0.45;';
    var valueSpan = document.createElement('span');
    valueSpan.style.cssText = 'font-weight:500;';
    labelRow.appendChild(titleSpan);
    labelRow.appendChild(valueSpan);

    /* Track with padding so thumb never clips */
    var pad = THUMB_SIZE / 2 + 1;
    var trackOuter = document.createElement('div');
    trackOuter.style.cssText = 'padding:0 ' + pad + 'px;';

    var trackArea = document.createElement('div');
    trackArea.style.cssText = 'position:relative;height:32px;cursor:pointer;touch-action:none;user-select:none;-webkit-user-select:none;';

    var bgTrack = document.createElement('div');
    bgTrack.style.cssText = 'position:absolute;left:0;right:0;top:50%;transform:translateY(-50%);height:2px;background:currentColor;opacity:0.12;border-radius:1px;';

    var fill = document.createElement('div');
    fill.style.cssText = 'position:absolute;top:50%;transform:translateY(-50%);height:2px;background:' + THUMB_COLOR + ';border-radius:1px;left:0%;';

    var thumb = document.createElement('div');
    thumb.style.cssText = 'position:absolute;top:50%;width:' + THUMB_SIZE + 'px;height:' + THUMB_SIZE + 'px;border-radius:50%;background:' + THUMB_COLOR + ';transform:translate(-50%,-50%);cursor:grab;touch-action:none;z-index:2;box-shadow:0 0 0 2px var(--color-background,#fff);';

    trackArea.appendChild(bgTrack);
    trackArea.appendChild(fill);
    trackArea.appendChild(thumb);
    trackOuter.appendChild(trackArea);

    var bounds = document.createElement('div');
    bounds.style.cssText = 'display:flex;justify-content:space-between;font-size:0.7em;opacity:0.3;margin-top:2px;padding:0 ' + pad + 'px;';
    var bL = document.createElement('span'); bL.textContent = '$0';
    var bR = document.createElement('span'); bR.textContent = '$' + sliderMax.toLocaleString();
    bounds.appendChild(bL);
    bounds.appendChild(bR);

    sliderWrap.appendChild(labelRow);
    sliderWrap.appendChild(trackOuter);
    sliderWrap.appendChild(bounds);

    wrap.appendChild(sortList);
    wrap.appendChild(sliderWrap);
    facet.appendChild(wrap);

    /* ---- Render ---- */
    function render() {
      thumb.style.left = pct(maxVal) + '%';
      fill.style.right = (100 - pct(maxVal)) + '%';
      valueSpan.textContent = maxVal >= sliderMax
        ? '$' + sliderMax.toLocaleString() + '+'
        : '$' + maxVal.toLocaleString();
    }

    /* ---- Drag ---- */
    var dragging = false;
    function getVal(cx) {
      var r = trackArea.getBoundingClientRect();
      return snap(Math.max(0, Math.min(1, (cx - r.left) / r.width)) * sliderMax);
    }
    function onDown(e) {
      e.preventDefault(); e.stopPropagation();
      dragging = true; thumb.style.cursor = 'grabbing';
      onMove(e);
      document.addEventListener('pointermove', onMove, { passive: false });
      document.addEventListener('pointerup', onUp);
    }
    function onMove(e) {
      if (!dragging) return;
      e.preventDefault();
      maxVal = Math.max(step, Math.min(sliderMax, getVal(e.clientX)));
      render();
    }
    function onUp() {
      if (!dragging) return;
      dragging = false; thumb.style.cursor = 'grab';
      document.removeEventListener('pointermove', onMove);
      document.removeEventListener('pointerup', onUp);
      applyMaxPrice(maxVal, rangeMax);
    }
    trackArea.addEventListener('pointerdown', onDown);

    render();
  }

  function initAll() {
    document.querySelectorAll('price-facet-component').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  var t;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(initAll, 150);
  }).observe(document.body, { childList: true, subtree: true });

  /* ---- Injected styles ---- */
  if (!document.getElementById('dbr-ps-css')) {
    var sty = document.createElement('style');
    sty.id = 'dbr-ps-css';
    sty.textContent = [
      'price-facet-component{display:block;overflow:visible}',
      '.facets--horizontal .facets__panel-content:has(.price-facet){min-width:340px}',
      /* Mobile drawer spacing */
      '.facets--drawer .facets__item+.facets__item,',
      '.facets--drawer .facets__item+.sorting-filter{margin-top:16px;padding-top:16px;}',
      /* Clean up price display in filter bar */
      '.facets__status .hide-when-empty{font-variant-numeric:tabular-nums}',
    ].join('\n');
    document.head.appendChild(sty);
  }

  /* ---- Clean price text in status bar (remove .00) ---- */
  function cleanPriceText() {
    document.querySelectorAll('.facets__status .hide-when-empty, facet-remove-component, .facets-remove__pill, .filter-remove-buttons .button').forEach(function (el) {
      if (el.textContent.match(/\$[\d,.]+/)) {
        el.childNodes.forEach(function (node) {
          if (node.nodeType === 3 && node.textContent.match(/\.\d{2}/)) {
            node.textContent = node.textContent.replace(/\.00/g, '');
          }
        });
      }
    });
  }
  var pt;
  new MutationObserver(function () {
    clearTimeout(pt);
    pt = setTimeout(cleanPriceText, 200);
  }).observe(document.body, { childList: true, subtree: true });
  setTimeout(cleanPriceText, 300);
})();